import { render, staticRenderFns } from "./TrainingPrint.vue?vue&type=template&id=dada1fb6&"
import script from "./TrainingPrint.vue?vue&type=script&lang=js&"
export * from "./TrainingPrint.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports